import axiosInstance from "shared/axios";
import { CONFIGURATION_API } from "shared/constants";
import {queryparamBuilder} from 'shared/utils'

export const getConfigurationList = (search,params) => {
  let uri = CONFIGURATION_API.listing;
  if (search) {
    uri += `?${"search"}=${search}&`;
  } else if (Object.keys(params).length) {
    uri += "?";
  }
  uri += queryparamBuilder(params);
  return axiosInstance.get(`${uri}`);
};

/**
 * 
 * @author Ashish Yadav,Payment team and Tejas
 * @returns 
 */

export const getCustomConfigurationList = (search,params) => {
  let uri = CONFIGURATION_API.custom_config_list;
  if (search) {
    uri += `?${"search"}=${search}&`;
  } else if (Object.keys(params).length) {
    uri += "?";
  }
  uri += queryparamBuilder(params);
  return axiosInstance.get(`${uri}`);
};


export const addConfiguration = (param) => {
  let url = `${CONFIGURATION_API.listing}/create`;
  return axiosInstance.post(url, param);
};

export const updateConfiguration = (param, id) => {
  let url = `${CONFIGURATION_API.listing}/${id}`;
  return axiosInstance.patch(url, param);
};

/**
 * 
 * @author Ashish Yadav,Rahul team and Prajakta
 */
export const getReportsConfiguration = (id, subRef) => {
  let url = `${CONFIGURATION_API.listing}/report-configuration/${id}/${subRef}`
  return axiosInstance.get(url);
}

/**
 * 
 * @author Ashish Yadav,Rahul team and Prajakta
 * @returns 
 */
export const generateReports = (param) => {
  let url = `api/v1/reports/generate-report`
  return axiosInstance.post(url, param);
}

/**
 * 
 * @author Ashish Yadav,Rahul team and Prajakta
 * api/v1/reports/my-saved-reports
 */
export const getSavedReportsConfig = (_) => {
  let url = `api/v1/reports/my-saved-reports`
  return axiosInstance.get(url);
}

export const fetchConfigViewDetails = (param) => {
  const url = CONFIGURATION_API.view;
  return axiosInstance.get(url, { params: param });
};

